export default "__VITE_ASSET__ByM7knuP__"